import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { BiPlug } from 'react-icons/bi'
import { Wrench } from 'lucide-react'
import PayhelmLogo from '../../../assets/images/payhelm-logo-blue.png'
import { openCustomToolsModal } from '../integrationsSlice'
import { selectCustomTools } from '../../../features/openai/openaiSlice'

const logoClassName = 'tw-max-w-full tw-max-h-full'

export default function PayHelmMcpCustomToolsCard() {
  const dispatch = useDispatch()
  const tools = useSelector(selectCustomTools)
  const count = tools?.length ?? 0
  const hasTools = count > 0

  return (
    <div className="tw-col-span-1">
      <div className="tw-h-[240px] tw-flex tw-flex-col tw-rounded-lg tw-shadow-md tw-p-4 tw-bg-white hover:tw-ring hover:tw-ring-blue-600">
        <div className="tw-flex tw-items-center tw-justify-between tw-mb-6 tw-shrink-0">
          <div className="tw-w-24 tw-h-12 tw-flex tw-items-center tw-justify-start tw-gap-2">
            <img src={PayhelmLogo} className={logoClassName} alt="PayHelm logo" />
            <div className="tw-rounded-lg tw-bg-gradient-to-br tw-from-blue-500 tw-to-indigo-600 tw-p-1.5 tw-flex tw-items-center tw-justify-center">
              <Wrench className="tw-w-4 tw-h-4 tw-text-white" />
            </div>
          </div>
          <button
            type="button"
            className="tw-text-sm tw-cursor-pointer tw-rounded-md tw-border tw-border-slate-300 hover:tw-border-blue-600 hover:tw-bg-blue-600 hover:tw-text-white tw-transition-colors tw-duration-150 tw-shadow-sm tw-flex tw-items-center tw-space-x-2.5 tw-px-2.5 tw-py-1"
            onClick={() => dispatch(openCustomToolsModal())}
          >
            <BiPlug />
            <span>{hasTools ? 'Manage tools' : 'Set up'}</span>
          </button>
        </div>
        <div className="tw-flex tw-flex-col tw-min-h-0 tw-flex-1">
          <div className="tw-text-base tw-font-bold tw-mb-2 tw-shrink-0">PayHelm MCP Custom Tools</div>
          <div className="tw-text-slate-500 tw-text-sm tw-mb-3">
            Register HTTPS endpoints as tools your AI agent can call in Agent mode. Import from JSON Schema or add endpoints manually.
          </div>
          {hasTools && (
            <div className="tw-p-3 tw-rounded-xl tw-bg-slate-100 tw-text-slate-600 tw-text-sm">
              {count} custom tool{count !== 1 ? 's' : ''} configured
            </div>
          )}
        </div>
      </div>
    </div>
  )
}
